import appMarketIconUrl from '@/assets/user-sidebar/app-market.svg'
import businessWorkspaceIconUrl from '@/assets/user-sidebar/business-workspace.svg'
import coreAgentIconUrl from '@/assets/user-sidebar/core-agent.svg'
import historyIconUrl from '@/assets/user-sidebar/history.svg'
import newChatIconUrl from '@/assets/user-sidebar/new-chat.svg'

function FigmaIcon({ className, src }: { className: string; src: string }) {
  return <img alt="" aria-hidden className={className} src={src} />
}

export function AppMarketIcon() {
  return <FigmaIcon className="size-4" src={appMarketIconUrl} />
}

export function BusinessWorkspaceIcon() {
  return <FigmaIcon className="size-4" src={businessWorkspaceIconUrl} />
}

export function CoreAgentIcon() {
  return <FigmaIcon className="size-[14px]" src={coreAgentIconUrl} />
}

export function NewChatIcon() {
  return <FigmaIcon className="size-4" src={newChatIconUrl} />
}

export function HistoryIcon() {
  return <FigmaIcon className="h-[15px] w-[14px]" src={historyIconUrl} />
}
